import { useEffect, useRef, useState } from "react";
// import {GetPurchaseOrderMasterData} from '../store/purchaseOrderAtom';
import { Grid } from "@mui/material";
import {  GetVoucherListAtom } from "../../store/voucherAtom";
import moment from "moment";
import { useLocation,useParams,  useNavigate } from "react-router-dom";






function VoucherCorporateScroll(props) {
    const voucherAtom = GetVoucherListAtom();
    const mountRef = useRef(true)
    const [tableData, setTableData] = useState([]);
    const [checkedAll, setCheckAll] = useState(false);
    const { id } = useParams();

    const navigate = useNavigate();
    const { pathname } = useLocation();  
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];



    useEffect(() => {
        mountRef.current = true;

        if (voucherAtom.voucher_info?.length > 0) {
            setTableData(voucherAtom.voucher_info.map((ele) => { return { ...ele, checked: false } }));
        }

        return () => {
            mountRef.current = false;
        }
    }, [voucherAtom]);


    const onActionFilterPerform = (action) => {
        const option = action.target.value;
        if (Number(option) === 0) {
            return setTableData(voucherAtom.voucher_info);
        }
        var newList = voucherAtom.voucher_info.filter((item) => item.Sales_Order_Status_Id === Number(option));
        setTableData(newList);
    }


    const onCheckAllElement = async (selection) => {

        setCheckAll(prev => { return (!prev) });

        let newList = tableData?.map((item, i) => {
            return { ...item, checked: !selection }
        });

        await setTableData((prev) => {
            return [...newList];
        });
        // props?.onSelection(newList);
    }


    const onItemSelect = (id)=> {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    }



    const onCheckboxClick = async (e, index) => {
        let element = tableData[index];
        tableData[index] = { ...element, checked: e.target.checked };
        await setTableData((prev) => {
            return [...tableData];
        });
        props?.onSelection(tableData);
    };


    const managePurchaseStatus = (status) => {
        let defaultClass = "color1";

        switch (status) {
            case "Draft":
                defaultClass = "color2";
                break;
            case "Approved":
                defaultClass = "color3";
                break;
            case "Pending for Approval":
                defaultClass = "color4";
                break;
            case "Fulfilled":
                defaultClass = "color5";
                break;
            case "Rejected":
                defaultClass = "color6";
                break;
            case "Confirmed":
                defaultClass = "color1";
                break;
            case "Partially Billed":
                defaultClass = "color8";
                break;

            default:
                break;
        }

        return (
            <span className={`text-sm font-bold md:text-sm ${defaultClass} `}>
                {status}
            </span>
        );
    };



    return (
        <>

<section className="w-full z-0 border-2 border-gray-200 rounded-lg p-4 bg-gray-50">
  {tableData?.map((ele, i) => (
    <div
      key={i}
      onClick={() => onItemSelect(ele?.Corporate_Ref_No)}
      className={`flex items-center justify-between p-4 mb-2 rounded-lg border border-gray-200 hover:bg-blue-50 cursor-pointer transition-colors duration-200 ${
        Number(id) === ele?.Corporate_Ref_No ? 'bg-blue-100' : 'bg-white'
      }`}
    >
      <div className="flex items-center gap-4">
        {/* Checkbox placeholder (commented out as in original) */}
        {/* <input type="checkbox" className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" /> */}
        <div>
          <span className="text-sm text-gray-500 md:text-sm">
            {moment(ele?.Created_Date).format("DD/MM/YYYY")}
          </span>
          <br />
          <span className="text-md font-medium text-blue-700">
            {ele?.Corporate_Name}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-md text-gray-600">Total:</span>
        <span className="text-md font-semibold text-blue-700">
          {ele?.Voucher_Quantity}
        </span>
      </div>
    </div>
  ))}
</section>
        </>
    );
}

export default VoucherCorporateScroll;
